import { Card } from '@splitfiesta/ui';

import { Skeleton } from './SkeletonComponents';

export function SettingsPageSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      {/* Header - matches h1 text-3xl and p text-sm */}
      <div>
        <Skeleton className="w-28 sm:w-32 h-8 sm:h-9 mb-1" />
        <Skeleton className="w-64 sm:w-80 h-4" />
      </div>

      <div className="space-y-8">
        {/* App Preferences - matches Card component exactly */}
        <Card>
          {/* Section header - h3 text-lg font-semibold with icon */}
          <div className="flex items-center mb-4">
            <Skeleton className="w-5 h-5 mr-2" />
            <Skeleton className="w-28 sm:w-32 h-6" />
          </div>
          <div className="space-y-6">
            {/* Language field */}
            <div>
              {/* h4 text-sm font-medium mb-3 */}
              <Skeleton className="w-16 sm:w-20 h-4 mb-3" />
              {/* p text-xs mb-4 */}
              <Skeleton className="w-56 sm:w-72 h-3 mb-4" />
              {/* Select input */}
              <Skeleton className="w-full h-10 rounded-md" />
            </div>

            {/* Currency field */}
            <div>
              <Skeleton className="w-20 sm:w-24 h-4 mb-3" />
              <Skeleton className="w-64 sm:w-80 h-3 mb-4" />
              <Skeleton className="w-full h-10 rounded-md" />
            </div>
          </div>
        </Card>

        {/* Notification Preferences */}
        <Card>
          {/* Section header */}
          <div className="flex items-center mb-4">
            <Skeleton className="w-5 h-5 mr-2" />
            <Skeleton className="w-32 sm:w-40 h-6" />
          </div>
          {/* Notification toggles - matches FormSwitch structure */}
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map(i => (
              <div
                key={i}
                className="flex items-start sm:items-center justify-between py-2 gap-4"
              >
                <div className="flex-1 min-w-0">
                  {/* Label */}
                  <Skeleton className="w-32 sm:w-40 h-4 mb-1" />
                  {/* Description */}
                  <Skeleton className="w-48 sm:w-64 h-3" />
                </div>
                {/* Toggle switch */}
                <Skeleton className="w-11 h-6 rounded-full shrink-0" />
              </div>
            ))}
          </div>
        </Card>

        {/* Danger zone (account deletion) */}
        <Card>
          <Skeleton className="w-40 h-5 mb-2" />
          <Skeleton className="w-64 h-3 mb-4" />
          <div className="space-y-2">
            <Skeleton className="w-full h-3" />
            <Skeleton className="w-5/6 h-3" />
            <Skeleton className="w-4/6 h-3" />
          </div>
          <Skeleton className="w-56 h-9 mt-4 rounded-lg" />
        </Card>
      </div>
    </div>
  );
}
